<div class="close-popup-wrap">
  <button class="close-popup" (click)="closePopup()">
    <span class="close-text">{{ 'PopupForm:Close' | translate }}</span>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<div class="video-wrap">
  <iframe [src]="heroVideo" width="640" height="360" allow="autoplay" title="Featured video" allowfullscreen></iframe>
</div>
